export default __webpack_public_path__ + "static/media/right_connect.d3313368.svg";